/**
 * @docs docs/features/opportunities
 * @adr  ADR-0074
 * @rule A dated edition, permanent and frozen as of its date. Never static: the latest edition flips at 06:00 UTC.
 */

import { definePageRoute } from '@common/router/definitions';

import { buildEditionsRouteData, renderEditionsRoute } from './lib/editionsRoute';

export default definePageRoute({
    path: '/:editionPage(business-ideas|trending-domains)/:date(\\d{4}-\\d{2}-\\d{2})',
    options: { auth: false, layout: false },
    data: buildEditionsRouteData,
    render: renderEditionsRoute,
});
